import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskRequirementApplicationDebriefRemoved_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskRequirementApplicationDebriefRemoved_ActivityLogFragment;
}

const ActivityLogTaskRequirementApplicationDebriefRemoved: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.removedDebriefRequirement"
    />
  );
};

ActivityLogTaskRequirementApplicationDebriefRemoved.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskRequirementApplicationDebriefRemoved_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskRequirementApplicationDebriefRemoved;
